import { useEffect, useState } from "react";

const SHEET_ID   = "1MVmmzs6rULqdqq2kgGlewrlSVnfMOYvbXs9dU83-jIo";
const SHEET_NAME = "media";
const SHEET_URL  = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?tqx=out:json&sheet=${SHEET_NAME}`;

function convertDriveLink(url) {
  if (!url) return url;
  let fileId = null;
  const ucMatch   = url.match(/[?&]id=([\w-]+)/);
  const fileMatch = url.match(/\/file\/d\/([\w-]+)/);
  if (ucMatch)        fileId = ucMatch[1];
  else if (fileMatch) fileId = fileMatch[1];
  if (fileId) return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1600-h900`;
  return url;
}

export default function useMedia() {
  const [media, setMedia] = useState([]);

  useEffect(() => {
    fetch(SHEET_URL)
      .then((res) => res.text())
      .then((text) => {
        // ✅ Robust parser — works regardless of Google's prefix length
        const match = text.match(/setResponse\(([\s\S]*?)\);/);
        if (!match) {
          console.warn("[useMedia] Could not parse sheet response");
          return;
        }
        const json = JSON.parse(match[1]);
        const rows = json?.table?.rows || [];

        const parsed = rows
          .map((r) => ({
            section:   r.c[0]?.v ?? null,
            subgroup:  r.c[1]?.v != null ? String(r.c[1].v) : null,
            category:  r.c[2]?.v ?? null,
            image_url: convertDriveLink(r.c[3]?.v),
            caption:   r.c[4]?.v ?? null,
            // ✅ Normalize show value — handles "yes", "Yes", "YES"
            show:      r.c[5]?.v != null ? String(r.c[5].v).trim().toLowerCase() : "no",
            order:     r.c[6]?.v ?? null,
          }))
          .filter((m) => m.show === "yes");

        console.log("[useMedia] Loaded rows:", parsed.length, parsed);
        setMedia(parsed);
      })
      .catch((err) => {
        console.warn("[useMedia] Media fetch failed:", err.message);
      });
  }, []);

  return media;
}